import React, { useRef, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Autocomplete, Button, ButtonProps, Popover, Stack, TextField } from "@mui/material";

import { useInvestorsSelector } from "../../store";
import { IInvestor } from "../../store/types";

interface Props extends ButtonProps {
  plaidReady: boolean;
  investor: IInvestor | null;
  setInvestor: (investor: IInvestor) => void;
  onConnect: () => void;
}

const Link = (props: Props) => {
  const { plaidReady, investor, setInvestor, onConnect, ...buttonProps } = props;
  const ref = useRef<HTMLButtonElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const investors = useInvestorsSelector();

  return (
    <>
      <Button onClick={() => setMenuOpen(true)} startIcon={<AddIcon fontSize="md" />} ref={ref} {...buttonProps}>
        Add Plaid Connection
      </Button>
      <Popover anchorEl={ref.current} open={menuOpen} onClose={() => setMenuOpen(false)}>
        <Stack minWidth={300} minHeight={80} justifyContent="flex-end" gap={"12px"} padding="12px">
          <Autocomplete<IInvestor>
            size="small"
            multiple={false}
            fullWidth
            // @ts-ignore
            getOptionLabel={(option) => option.name}
            options={investors}
            value={investor}
            onChange={(e, option) => {
              setInvestor(option!);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="Investor"
                placeholder="Choose Investor"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
            )}
          />
          <Button variant="contained" disabled={!plaidReady || !investor} onClick={onConnect}>
            Connect
          </Button>
        </Stack>
      </Popover>
    </>
  );
};

Link.displayName = "Link";

export default Link;
